import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { TIDS } from "@/constants/testIds";

const links = [
  { to: "/", label: "Home", tid: TIDS.nav.home, end: true },
  { to: "/about", label: "About", tid: TIDS.nav.about },
  { to: "/work", label: "Work", tid: TIDS.nav.work },
  { to: "/services", label: "Services", tid: "nav-services" },
  { to: "/testimonials", label: "Testimonials", tid: TIDS.nav.testimonials },
  { to: "/contact", label: "Contact", tid: TIDS.nav.contact },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[min(1240px,calc(100%-2rem))]">
      <nav className="glass-nav rounded-full pl-5 pr-3 py-2.5 flex items-center justify-between">
        <Link
          to="/"
          data-testid={TIDS.nav.logo}
          className="flex items-center gap-2 group"
          onClick={() => setOpen(false)}
        >
          <span className="w-8 h-8 rounded-full bg-[#0B0B0B] text-[#FFC629] font-display text-lg flex items-center justify-center leading-none">
            ID
          </span>
          <span className="hidden sm:inline text-sm font-semibold tracking-tight text-[#0B0B0B]">
            Illustrative Digital
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-[#1D2AE8]">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.tid}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <Link
          to="/contact"
          data-testid={TIDS.nav.cta}
          className="hidden md:inline-flex items-center gap-1.5 text-sm font-medium text-[#0B0B0B]/70 hover:text-[#0B0B0B]"
        >
          <span className="w-2 h-2 rounded-full bg-[#FF3D6A] inline-block animate-pulse" />
          Kolkata · IST
        </Link>

        <button
          data-testid={TIDS.nav.mobileToggle}
          className="md:hidden w-10 h-10 rounded-full bg-[#0B0B0B] text-[#FFC629] flex items-center justify-center"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden mt-2 glass-light rounded-3xl p-6 flex flex-col gap-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              onClick={() => setOpen(false)}
              data-testid={`${l.tid}-mobile`}
              className={({ isActive }) =>
                `text-lg font-display ${isActive ? "text-[#1D2AE8]" : "text-[#0B0B0B]/80"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            onClick={() => setOpen(false)}
            className="btn-ink justify-center mt-2"
          >
            Say hello <ArrowUpRight size={16} />
          </Link>
        </div>
      )}
    </header>
  );
}
